"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var kendo_react_common_1 = require("@progress/kendo-react-common");
/**
 * Represents the KendoReact FieldWrapper component.
 * It's designed to wrap the field editor, Label, Hint and Error components.
 * The FieldWrapper supports only single editor inside it.
 */
exports.FieldWrapper = function (props) {
    var fieldClassName = kendo_react_common_1.classNames({
        'k-form-field': true,
        'k-rtl': props.dir === 'rtl'
    }, props.className);
    return (React.createElement("div", { className: fieldClassName, style: props.style }, props.children));
};
exports.FieldWrapper.displayName = 'KendoReactFieldWrapper';
//# sourceMappingURL=FieldWrapper.js.map


//////////////////
// WEBPACK FOOTER
// /Users/larsmarin/Documents/Workspaces/AAG/aag-amc-projects/~/.pnpm/@progress+kendo-react-form@3.18.0_react-dom@16.14.0_react@16.14.0__react@16.14.0/~/@progress/kendo-react-form/dist/npm/FieldWrapper.js
// module id = 6553
// module chunks = 0